import {Link, useCatch} from '@remix-run/react'
import {Document} from '../ErrorBoundary'

export function CatchBoundary() {
  const caught = useCatch()
  let message

  switch (caught.status) {
    case 400:
      message = <p>Oops! Looks like something went wrong.</p>
      break
    case 401:
      message = (
        <p>
          Oops! Looks like you tried to visit a page that you do not have access
          to.
        </p>
      )
      break
    case 403:
      message = (
        <p>
          Your subscription licence does not give you access to this product.
          Please contact your client success manager if you would like to gain
          access. You can also contact us{' '}
          <Link to="/get-in-touch" className="text-primary-600">
            here
          </Link>{' '}
          for help.
        </p>
      )
      break
    case 404:
      message = (
        <p>Oops! Looks like you tried to visit a page that does not exist.</p>
      )
      break
    case 500:
      message = (
        <p>
          Oops! The server encountered an internal error and was unable to
          complete your request.
        </p>
      )
      break

    default:
      throw new Error(caught.data || caught.statusText)
  }

  return (
    <Document>
      <div className="items-top relative mt-24 flex items-center justify-center sm:pt-0">
        <div className="mx-auto max-w-md sm:px-6 lg:px-8">
          <div className="flex pt-8 sm:pt-0">
            <div className="border-r border-gray-400 pr-4 text-lg tracking-wider text-gray-500">
              {caught.status}
            </div>

            <div className="ml-4 text-lg uppercase tracking-wider text-gray-500">
              Error
            </div>
          </div>
          <div className="mt-6 text-sm dark:text-gray-500">{message}</div>
        </div>
      </div>
    </Document>
  )
}
